import * as tslib_1 from "tslib";
import { DataCollection } from '../data_collection';
var Flat = /** @class */ (function (_super) {
    tslib_1.__extends(Flat, _super);
    function Flat(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'groupable,group';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    Flat.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "Flat",
            "groupable": this.groupable,
            "group": this.group,
        });
    };
    Flat.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Flat;
}(DataCollection));
export { Flat };
//# sourceMappingURL=flat.js.map